import { render, staticRenderFns } from "./InvitesList.vue?vue&type=template&id=9a72abe8&scoped=true&"
import script from "./InvitesList.vue?vue&type=script&lang=js&"
export * from "./InvitesList.vue?vue&type=script&lang=js&"
import style0 from "./InvitesList.vue?vue&type=style&index=0&id=9a72abe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a72abe8",
  null
  
)

export default component.exports